import React, { useEffect, useState } from "react";
import "../App.css";
import Nav from "./Navigation.js";

export default function StatsItems() {
  const [allItems, setAllItems] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [itemVisibility, setItemVisibility] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_HOST}/api/stats/items`)
      .then((res) => (res.ok ? res.json() : []))
      .then((data) => {
        setAllItems(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching stats:", err);
        setLoading(false);
      });
  }, []);

  const toggleVisibility = (itemName) => {
    setItemVisibility((prev) => ({
      ...prev,
      [itemName]: !prev[itemName],
    }));
  };

  const filtered = allItems.filter((item) => {
    const matchesEvent = selectedEvent === "" || item.event === selectedEvent;
    const matchesSearch = searchTerm === "" || item.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesEvent && matchesSearch;
  });

  // Already sorted by percentage ASC from backend (rarest first)
  const sorted = [...filtered].sort((a, b) => {
    if (a.percentage !== b.percentage) return a.percentage - b.percentage;
    return a.name.localeCompare(b.name);
  });

  const uniqueEvents = [...new Set(allItems.map((i) => i.event))].filter(Boolean).sort();

  return (
    <div>
      <Nav />
      <div className="text-white">
        <div className="Title">Complete List of Items</div>
        <div className="mb-4">
          <label htmlFor="eventDropdown" className="text-md font-bold">
            Select Event:
          </label>
          <select
            id="eventDropdown"
            onChange={(e) => setSelectedEvent(e.target.value)}
            value={selectedEvent}
            className="ml-2 p-1 border rounded text-black"
          >
            <option value="">All</option>
            {uniqueEvents.map((event) => (
              <option key={event} value={event}>{event}</option>
            ))}
          </select>
          Or search
          <input
            type="text"
            placeholder="Search by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="ml-2 p-1 border rounded text-black"
          />
          <button
            onClick={() => { setSelectedEvent(""); setSearchTerm(""); }}
            className="ml-2 p-1 border rounded"
          >
            Reset/Clear
          </button>
        </div>

        {loading ? (
          <p className="text-gray-400 ml-2">Loading stats…</p>
        ) : (
          <div className="flex flex-wrap">
            {[...new Set(sorted.map((i) => i.maps))].map((map) => (
              <div key={map} className="mb-6 ml-2 w-full">
                <h3 className="text-lg font-bold mb-2">{map} Maps</h3>
                {[...new Set(sorted.filter((i) => i.maps === map).map((i) => i.types))].map((type) => (
                  <div key={type} className="mb-4">
                    <h4 className="text-md font-bold mb-2">{type} Types</h4>
                    <div className="grid gap-2 grid-cols-1 md:grid-cols-1">
                      {sorted
                        .filter((i) => i.maps === map && i.types === type)
                        .map((item) => (
                          <div className="border-b-2" key={item.id}>
                            <div className="grid grid-cols-4 gap-4 items-center">
                              <div className="border p-2 rounded flex">
                                <button
                                  className="bg-blue-500 border-solid border-2 border-white text-white rounded"
                                  onClick={() => toggleVisibility(item.name)}
                                >
                                  {itemVisibility[item.name] ? "Hide" : "Info"}
                                </button>
                                <div className="font-bold ml-2">{item.name}</div>
                              </div>
                              <div className="p-2 flex">
                                <div className="font-bold pr-2">Owned By:</div>
                                <div>{item.checked_count} / {item.total_users}</div>
                              </div>
                              <div className="p-2 flex">
                                <div className="font-bold pr-2">Percentage:</div>
                                <div>{item.percentage.toFixed(1)}%</div>
                              </div>
                            </div>
                            {itemVisibility[item.name] && item.url && (
                              <div className="mt-2">
                                <img
                                  className="object-scale-down h-48 cursor-pointer"
                                  src={`${process.env.REACT_APP_R2_PUBLIC_URL}/${item.url}`}
                                  alt={item.name}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
